<template>
<div class="table-responsive">
  <table class="table table-hover" :class="cssClasses">
    <thead>
      <tr>
        <th scope="col" v-for="(header, headerIndex) in tableHeadings" :key="headerIndex" :class="header.cssClass ? header.cssClass:''">{{header.name}}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, rowIndex) in tableData" :key="'row-'+rowIndex">
        <td scope="row" v-for="(data, dataIndex) in row" :key="'data-'+rowIndex+'-'+dataIndex" :class="data.columnClass ? data.columnClass:''">
          <span v-if="data.type === 'info'">{{data.value}}</span>
          <span v-else-if="data.type === 'switch'">
            <IOSSwitch :id="data.inputProps.id" :label="data.inputProps.label ? data.inputProps.label:''" :required="data.inputProps.required ? data.inputProps.required:false" :checked="localModel[data.inputProps.modelPropName]" v-model="localModel[data.inputProps.modelPropName]" :inputDisabled="inputDisabled"  />
          </span>
          <span v-else-if="data.type === 'input'">
            <b-input :name="data.inputProps.name" :disabled="inputDisabled" :id="data.inputProps.id" :type="data.inputProps.type" :required="data.inputProps.required ? data.inputProps.required:false" :placeholder="data.inputProps.placeholder" v-model.number="localModel[data.inputProps.modelPropName]"></b-input>
          </span>
          <span v-else>
            &nbsp;
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
</template>

<script>
import IOSSwitch from '@/components/IOSSwitch/IOSSwitch';

export default {
  name: "TableWithInputs",
  components: {
    IOSSwitch
  },
  props: {
    cssClasses: {
      default: "",
      type: String,
      required: false
    },
    tableHeadings: {
      type: Array,
      required: true
    },
    tableData: {
      type: Array,
      required: true
    },
    model: {
      type: Object,
      required: true
    },
    inputDisabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    localModel: {
      get() {
        return this.model
      },
      set(localModel) {
        this.$emit('input', localModel)
      }
    }
  }
}
</script>

<style src="./TableWithInputs.scss" lang="scss" scoped/>
